import { notifications } from '@mantine/notifications';
import { IconPlus } from '@tabler/icons-react';
import { useApi } from 'api/api-context';
import EvidenceFieldForm, { EvidenceFieldFormData } from 'components/forms/evidence-field/EvidenceFieldForm';
import panic from 'errors/panic';
import DashboardLayout from 'layouts/dashboard/DashboardLayout';
import { ROLE_ADMIN_ID } from 'model/Role';
import { Navigate, useNavigate } from 'react-router-dom';
import { DASHBOARD_PAGE_PATH, EVIDENCE_FIELDS_PAGE_PATH } from 'routes/paths';
import { SUCCESS_NOTIFICATION_COLOR } from 'utils/constants';

/**
 * Page used to add a new organization.
 *
 */
export default function AddEvidenceFieldPage() {
  const navigate = useNavigate();
  const { getAction, roleId } = useApi();

  if (roleId !== ROLE_ADMIN_ID) {
    return <Navigate to={DASHBOARD_PAGE_PATH.original} replace />;
  }

  /**
   * Runs when the form is submitted.
   */
  function onSubmit({
    selectedDeviceTypes,
    selectedOrganizations,
    precision = 0,
    predefinedDataTypeId,
    selectOptions = [],
    ...data
  }: EvidenceFieldFormData) {
    const createField = getAction('DeviceCreateEvidenceField');

    const payload = {
      ...data,
      sectionId: Number(data.sectionId),
      precision,
      selectOptions: selectOptions.map((option) => option.trim()),
      predefinedDataTypeId: predefinedDataTypeId ? Number(predefinedDataTypeId) : undefined,
      selectedDeviceTypes: selectedDeviceTypes.map(Number),
      selectedOrganizations: selectedOrganizations.map(Number),
    };

    return createField({ payload })
      .then(() => {
        notifications.show({
          title: 'Evidenčné pole bolo vytvorené',
          message: `Evidenčné pole ${data.fieldName} bol úspešne vytvorený.`,
          color: SUCCESS_NOTIFICATION_COLOR,
        });

        navigate(EVIDENCE_FIELDS_PAGE_PATH.original);
      })
      .catch(panic);
  }

  return (
    <DashboardLayout
      title="Pridanie nového evidenčného poľa"
      breadcrumbs={[
        { title: 'Evidenčné polia', link: EVIDENCE_FIELDS_PAGE_PATH.original },
        { title: 'Pridanie nového evidenčného poľa' },
      ]}
    >
      <EvidenceFieldForm
        onSubmit={onSubmit}
        primaryButtonText="Vytvoriť"
        primaryIcon={<IconPlus stroke="1.5" height={24} width={24} />}
      />
    </DashboardLayout>
  );
}
